import { type ProfileItem } from '@/common/types/profile.type';
import { type ResponseItemType } from '@/common/types/response.type';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/common/hooks/use-session.hook';
import Client from '@/common/utils/client.utility';

export type UpdateProfileType = () => Promise<ResponseItemType<ProfileItem>>;

const getProfile: UpdateProfileType = async () => {
  const client = new Client();

  return await client.get('/v1/Identity/User/Profile');
};

export function useGetProfile({ enabled }: { enabled?: boolean }) {
  const { data: session } = useSession();
  const sessionProfile = session?.profile;
  return useQuery({
    queryKey: ['Profile'],
    queryFn: async () => await getProfile(),
    select: (data) => data?.data,
    enabled: enabled && !sessionProfile,
    initialData: sessionProfile ? { data: sessionProfile } : undefined,
    staleTime: sessionProfile ? Infinity : 0,
  });
}
